export const mapWithList = <T, D>(mapper: (response: D) => T) => (list: D[] | undefined) => (list ?? []).map(mapper);
